// @flow
import * as React from 'react';
import styled, { type StyledComponent } from 'styled-components';
import { Link } from '../../typography';
import ArrowLeftIcon from '../../icons/arrow_left';
import type { DataProvidesProps } from '../../utils/constants';
import { getDataProvidesProps } from '../../utils/constants';

type BackContentProps = {
  children: string,
};
const BackContent = (props: BackContentProps) => (
  <>
    <ArrowLeftIcon />
    {props.children}
  </>
);

type BackLinkProps = {
  /**
   * Contents of the back crumb, must be text.
   */
  children: string,
  /**
   * The link that clicking the back crumb will take you to.
   */
  href: string,
  ...DataProvidesProps,
};

const BackLink = (props: BackLinkProps) => (
  <Link href={props.href} {...getDataProvidesProps(props)}>
    <BackContent>{props.children}</BackContent>
  </Link>
);

type BackButtonProps = {
  /**
   * Contents of the back crumb, must be text.
   */
  children: string,
  /**
   * Fires when the link is clicked.
   */
  onClick: (evt: SyntheticEvent<HTMLButtonElement>) => void,
  ...DataProvidesProps,
};

const StyledLinkButton: StyledComponent<*, *, *> = styled(Link)`
  background: none;
  border: none;
  padding: 0;
`;

const BackButton = (props: BackButtonProps) => (
  <StyledLinkButton
    forwardedAs={'button'}
    onClick={props.onClick}
    {...getDataProvidesProps(props)}
  >
    <BackContent>{props.children}</BackContent>
  </StyledLinkButton>
);

export { BackLink, BackButton };
